import CoinCounter from "./CoinCounter";

export default class CoinCounterGroup {
  scene: Phaser.Scene;
  stored: CoinCounter[];
  spawned: CoinCounter[];
  consecutiveCount: number;
  lastPickupTime: number;
  consecutiveTimeWindow: number;
  batchSize: number;
  pendingCounters: CoinCounter[];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.stored = [];
    this.spawned = [];
    this.pendingCounters = [];
    this.consecutiveCount = 0;
    this.lastPickupTime = 0;
    this.consecutiveTimeWindow = 2000; // 2 seconds window for consecutive pickups
    this.batchSize = 10; // Clean up counters in batches of 10
  }

  Init() {
    // Create pool of counters
    for (let i = 0; i < 10; i++) {
      const counter = new CoinCounter(this, 0, 0);
      counter.Init();
      this.stored.push(counter);
    }
  }

  Spawn(x: number, y: number) {
    const currentTime = this.scene.time.now;

    // Check if this pickup is within the consecutive time window
    if (currentTime - this.lastPickupTime < this.consecutiveTimeWindow) {
      // Increment consecutive count
      this.consecutiveCount++;
    } else {
      // Reset consecutive count if too much time has passed
      this.consecutiveCount = 1;
    }

    // Update last pickup time
    this.lastPickupTime = currentTime;

    // Clean up previous counters if needed
    this.cleanupCounters();

    // Show counter with the consecutive count
    this.ShowCounter(x, y, this.consecutiveCount);
  }

  cleanupCounters() {
    // If we've reached the next multiple of batchSize (e.g., 11, 21, 31, etc.)
    // and we have counters showing values in the previous batch, remove them instantly
    if (
      this.consecutiveCount > this.batchSize &&
      this.consecutiveCount % this.batchSize === 1
    ) {
      // Find counters that show previous batch values
      const countersToRemove = this.spawned.filter((counter) => {
        // Keep counters from over 10 ago (e.g., if count is 31, we remove counters for 21-30)
        const batchStart = this.consecutiveCount - this.batchSize;
        return (
          counter.coinCount >= batchStart &&
          counter.coinCount < this.consecutiveCount
        );
      });

      // Remove these counters immediately (no fading)
      countersToRemove.forEach((counter) => {
        // Stop any active tweens
        if (counter.tween1) counter.tween1.stop();
        if (counter.tween2) counter.tween2.stop();

        // Return counter to pool
        counter.DeSpawn();
      });
    }
  }

  ShowCounter(x: number, y: number, count: number) {
    if (this.stored.length === 0) {
      const counter = new CoinCounter(this, 0, 0);
      counter.Init();
      this.stored.push(counter);
    }

    const counter = this.stored.pop();
    if (counter) {
      counter.OnRecycle(x, y, count);
      this.spawned.push(counter);
    }
  }

  Return(counter: CoinCounter) {
    const index = this.spawned.indexOf(counter);
    if (index !== -1) {
      this.spawned.splice(index, 1);
      this.stored.push(counter);
    }
  }
}
